import { Pipe, PipeTransform } from '@angular/core';
import { IExportStructure } from '../../../models/export/export-structure.model';
import {
  getValue,
  isDefined,
  isDefinedAndFilledArray,
  isDefinedAndFilledString,
} from '../../utility/verify.lib';

@Pipe({
  name: 'isNotIncluded',
})
export class IsNotIncludedPipe implements PipeTransform {
  public transform(
    textsToCheck: IExportStructure[],
    alreadyIncludedList: string[],
    skipCurrentSelectedShortName: string
  ): IExportStructure[] {
    const returnValue: IExportStructure[] = [];

    if (isDefinedAndFilledArray(() => textsToCheck)) {
      textsToCheck.forEach((structure: IExportStructure) => {
        if (
          isDefinedAndFilledString(() => structure.shortName) &&
          (structure.shortName === skipCurrentSelectedShortName ||
            !alreadyIncludedList.includes(structure.shortName))
        ) {
          returnValue.push(structure);
        }
      });
    }

    return returnValue;
  }
}
